export default function useIsApp() {
  if (typeof window === 'undefined') return false;

  // Flutter WebView에서 흔히 주입
  if (window.FlutterChannel) return true;

  // 커스텀 UA 사용하는 경우
  const ua = navigator.userAgent || '';
  if (ua.includes('PONYLINK_APP')) return true;

  return false;
}
